export default "__VITE_ASSET__9919541d__"